import qs from 'qs'
import { fetch } from '@/api/fetch'
import api from './url' //引用url.js

/**
 * 登录
 * @param username // 账户
 * @param password // 密码
 */
export function login(params: object) {
  return fetch({
    url: api.path + '/user/login',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
}

// 企业微信登录
export function getLoginInfo(params: object) {
  return fetch({
    url: api.path + `/login/getLoginInfo`,
    method: 'post',
    data: params
  })
}

export function codeLogin(params: object) {
  return fetch({
    url: api.path + `/login/codeLogin`,
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    },
    data: params,
    transformRequest: [
      function(data: any) {
        let ret = ''
        for (let it in data) {
          ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        }
        return ret
      }
    ]
  })
}

// 退出登录
export function loginout() {
  return fetch({
    url: api.path + `/user/loginout`,
    method: 'post'
  })
}

/**
 * 查询字典
 * @param parent_code
 */
export function queryDictsByCode(params: object) {
  return fetch({
    url: api.path + '/sysdict/queryDictsByCode',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: params
  })
}

/**
 * 查询字典树
 * @param parent_code
 */
export function queryDictsTreebyCode(params: object) {
  return fetch({
    url: api.path + '/sysdict/queryDictsTreebyCode',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: params
  })
}

/**
 * 获取账户信息
 */
export function getUserInfo() {
  return fetch({
    url: api.path + '/userManage/queryInfo',
    method: 'post'
  })
}

/**
 * 修改个人信息
 * @param email     用户邮箱
 * @param image     头像地址
 * @param introduce 介绍
 * @param phone_num 用户手机
 * @param true_name 真实姓名
 * @param user_name 用户账号
 */
export function updateSelfInfo(params: object) {
  return fetch({
    url: api.path + '/userManage/updateSelfInfo',
    method: 'post',
    data: params
  })
}

/**
 * 查询自己的分享
 * @param page 页数
 * @param size 每页数量
 */
export function querySelfShare(params: object) {
  return fetch({
    url: api.path + '/share/querySelfShare',
    method: 'post',
    data: params
  })
}

/**
 * 添加分享
 * @param file       文件
 * @param file_type  文件后缀
 * @param type_code  课程类型
 * @param share_name 课程名字
 * @param share_desc 课程介绍
 * @param share_id   课程ID
 */
export function addShare(params: object) {
  return fetch({
    url: api.path + '/share/addShare',
    method: 'post',
    data: params
  })
}

/**
 * 发布分享
 * @param share_id 分享ID
 * @param states   发布状态：0已发布 1：未发布
 */
export function releaseShare(params: object) {
  return fetch({
    url: api.path + '/share/enableShare',
    method: 'post',
    data: params
  })
}

/**
 * 删除分享
 * @param share_id 分享ID
 * @param states   发布状态：0已发布 1：未发布
 */
export function deleteShare(params: object) {
  return fetch({
    url: api.path + '/share/delSelfShare',
    method: 'post',
    data: params
  })
}

/**
 * 查询自己话题
 * @param page 页数
 * @param size 每页数量
 */
export function getSelfTopic(params: object) {
  return fetch({
    url: api.path + '/topic/querySelfTopic',
    method: 'post',
    data: params
  })
}

/**
 * 发布话题看点
 * @param topic_id      话题ID
 * @param type_code     话题类型编码 默认传 talk
 * @param title_img     题图路径
 * @param topic_name    话题名称
 * @param topic_context 话题内容
 * @param topic_enable  话题状态
 */
export function updateTopic(params: object) {
  return fetch({
    url: api.path + '/topic/updateTopic',
    method: 'post',
    data: params
  })
}

/**
 * 删除话题看点
 * @param topic_id 话题ID
 */
export function delTopic(params: object) {
  return fetch({
    url: api.path + '/topic/delTopic',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
}

/**
 * 添加学习记录
 * @param course_id 课程ID
 */
export function addLearnRecord(params: object) {
  return fetch({
    url: api.path + '/learningRecords/addLearningRecord',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
}

/**
 * 添加完成学习记录
 * @param course_id 课程ID
 */
export function addFinishLearnRecord(params: object) {
  return fetch({
    url: api.path + '/finishCourse/addFinishCourse',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: qs.stringify(params)
  })
}

/**
 * 用户查询学习记录
 * @param page 页数
 * @param size 每页数量
 */
export function getLearnRecords(params: object) {
  return fetch({
    url: api.path + '/learningRecords/userQueryRecords',
    method: 'post',
    data: params
  })
}

/**
 * 用户查询学习记录
 * @param page 页数
 * @param size 每页数量
 */
export function getFinishRecords(params: object) {
  return fetch({
    url: api.path + '/finishCourse/userQueryRecords',
    method: 'post',
    data: params
  })
}

/**
 * 用户查询自己的考试列表
 */
export function querySelfExam() {
  return fetch({
    url: api.path + '/exam/querySelfExam',
    method: 'post'
  })
}

// 查询考试记录
export function queryExamHistory(params: object) {
  return fetch({
    url: api.path + `/exam/queryExamHistory`,
    method: "post",
    data: params
  });
}

/**
 * 获取试卷信息
 * @param histroy_id 试卷ID
 */
export function getTestPaper(params: object) {
  return fetch({
    url: api.path + '/exam/startExam',
    method: 'post',
    data: params
  })
}

/**
 * 提交试卷
 * @param exam_histroy_id    试卷ID
 * @param answer_sheet_items 答题内容
 * @param start_time         考试时间
 */
export function submitExam(params: object) {
  return fetch({
    url: api.path + '/exam/submitExam',
    method: 'post',
    data: params
  })
}

/**
 * 查看试题
 * @param flag  是否查询下级所有
 * @param point 知识点
 */
export function getQuestions(params: object) {
  return fetch({
    url: api.path + '/question/questionsPractice',
    method: 'post',
    data: params
  })
}

/**
 * 获取轮播图
 */
export function getBanner() {
  return fetch({
    url: api.path + '/homePage/queryHomePage',
    method: 'get'
  })
}

/**
 * 查询已发布企业大事件
 * @param page  页码
 * @param size  数量
 */
export function queryNews(params: object) {
  return fetch({
    url: api.path + '/news/queryNews',
    method: 'post',
    data: params
  })
}

/**
 * 根据父级查询课程类型
 * @param parent_id 父级ID
 */
export function queryCourseType(params: object) {
  return fetch({
    url: api.path + '/course/queryCourseType',
    method: 'post',
    data: params
  })
}

/**
 * 根据课程类型分页查询课程
 * @param type_code 父级ID
 * @param page      页码
 * @param size      数量
 */
export function getCourse(params: object) {
  return fetch({
    url: api.path + '/course/queryCourseByType',
    method: 'post',
    data: params
  })
}

/**
 * 查询员工风采
 * @param page 页码
 * @param size 数量
 */
export function queryStaffStyle(params: object) {
  return fetch({
    url: api.path + '/staffstyle/queryStaffStyle',
    method: 'post',
    data: params
  })
}

/**
 * 查询看点
 * @param type_code 话题类型 全部（传空）影视（movies）书籍（books）热点（hotspot）八卦（unofficial）我有话说（talk）
 * @param page      页码
 * @param size      数量
 */
export function getTopic(params: object) {
  return fetch({
    url: api.path + '/topic/queryTopicEnable',
    method: 'post',
    data: params
  })
}

/**
 * 添加话题看点
 * @param title_img     题图路径
 * @param type_code     话题类型
 * @param topic_name    标题
 * @param topic_context 正文
 */
export function addTopic(params: object) {
  return fetch({
    url: api.path + '/topic/addTopic',
    method: 'post',
    data: params
  })
}

/**
 * 查询话题评价
 * @param topic_id 看点ID
 * @param page     页码
 * @param size     数量
 */
export function getComments(params: object) {
  return fetch({
    url: api.path + '/topic/queryComments',
    method: 'post',
    data: params
  })
}

/**
 * 添加评论
 * @param topic_id        看点ID
 * @param comment_context 评论内容
 */
export function addComment(params: object) {
  return fetch({
    url: api.path + '/topic/addComment',
    method: 'post',
    data: params
  })
}

/**
 *  查询分享课程
 * @param type_code 课程code
 * @param page      页数
 * @param size      数量
 */
export function queryShareByType(params: object) {
  return fetch({
    url: api.path + '/share/queryShareByType',
    method: 'post',
    data: params
  })
}

/**
 *  修改密码
 * @param check_new_pwd 新密码确认
 * @param new_pwd       新密码
 * @param old_pwd       旧密码
 */
export function updatePwd(params: object) {
  return fetch({
    url: api.path + '/userManage/updatePwd',
    method: 'post',
    data: params
  })
}
